import * as React from "react";

import {Header} from "../components/Header";
import {Footer} from "../components/Footer";
import {ExchangeContent} from "../components/index/ExchangeContent";
import {AssetsContent} from "../components/index/AssetsContent";
import {IndexContent} from "../components/index/IndexContent";


export const IndexPage = () =>
    <>
    <div className="main__bg">
        <video autoPlay loop muted poster="img/bg.jpg" className="fullscreen-bg__video">
            <source src="img/video_bg.mp4" type="video/mp4" />
        </video>
        <div className="exchange">
            <Header />
            <ExchangeContent />
        </div>
        <AssetsContent />
    </div>
    <IndexContent/>
    <Footer isDark={true}/>
    </>

